module.exports = __webpack_public_path__ + "static/media/brand1.da655aab.png";